//React Components and Hooks
//Material UI Components
import Box from "@mui/material/Box";
//Material UI functions
import { makeStyles } from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
//Util
import moment from "moment";
import React from "react";
import { formatMoney } from "../../setup/helpers";
import FailureChip from "../../elements/Chips/FailureChip";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { NotInterestedOutlined } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Link from "@mui/material/Link";
//React Router
import { useNavigate } from "react-router-dom";
//Custom Components
import SuccessChip from "../../elements/Chips/SuccessChip";

const UbilCell = (props) => {
  const useStyles = makeStyles((theme) => {});
  const classes = useStyles();
  const navigate = useNavigate();
  let entry;
  const { column, data } = props;
  const { type, field, cellFunction, icons, linkRoute, linkField } = column;
  switch (type) {
    case "text":
      entry = data[field];
      switch (field) {
        case "fullName":
          entry = (data.firstName || "") + " " + (data.lastName || "");
          return (
            <TableCell key={data.uuid}>
              <Typography> {entry}</Typography>
            </TableCell>
          );
        case "billingAddress1":
          const { billingAddress1, billingCity, billingZip } = data;
          return (
            <TableCell key={data.uuid}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography>{billingAddress1}</Typography>
                <Typography>{billingCity}</Typography>
                <Typography>{billingZip}</Typography>
              </Box>
            </TableCell>
          );
        case "address1":
          const { address1, city, zip } = data;
          return (
            <TableCell key={data.uuid}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography>{address1}</Typography>
                <Typography>{city}</Typography>
                <Typography>{zip}</Typography>
              </Box>
            </TableCell>
          );
        default:
          return (
            <TableCell key={data.uuid}>
              <Typography>{entry}</Typography>
            </TableCell>
          );
      }
    case "date":
      entry = moment.utc(data[field]).format("L");
      return (
        <TableCell key={data.uuid}>
          <Typography>{entry}</Typography>
        </TableCell>
      );
    case "money":
      entry = data[field] != null ? formatMoney(data[field]) : "$0.00";
      return (
        <TableCell key={data.uuid}>
          <Typography>{entry}</Typography>
        </TableCell>
      );
    case "link":
      const linkValue = data[field];
      const route = linkRoute || "";
      // Support multiple route params via linkParams array or single linkField
      let routePath = route;
      if (column.linkParams && Array.isArray(column.linkParams)) {
        // Build path from array of field names: ["uuid", "id", "propertyManagerId"]
        const params = column.linkParams.map(paramField => data[paramField]).filter(Boolean);
        routePath = params.length > 0 ? `${route}/${params.join('/')}` : route;
      } else if (column.linkField) {
        // Single field fallback for backward compatibility
        const uuidValue = data[column.linkField];
        routePath = uuidValue ? `${route}/${uuidValue}` : route;
      }
      
      const hasValidRoute = routePath !== route;
      return (
        <TableCell key={data.uuid}>
          {hasValidRoute ? (
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate(routePath)}
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
                cursor: 'pointer',
              }}
            >
              {linkValue || ""}
            </Link>
          ) : (
            <Typography>{linkValue || ""}</Typography>
          )}
        </TableCell>
      );
    case "textInput":
      return <TableCell></TableCell>;
      break;
    case "dateInput":
      return <TableCell></TableCell>;
      break;
    case "chip":
      const { successLabel, failureLabel, renderCondition } = column;
      return (
        <TableCell>
          {renderCondition(data) ? (
            <SuccessChip text={successLabel} />
          ) : (
            <FailureChip text={failureLabel} />
          )}
        </TableCell>
      );
      break;
    case "dropDownInput":
      return <TableCell></TableCell>;
      break;
    case "icons":
      return (
        <TableCell key={data.uuid}>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
            {icons.map((tableIcon, index) => {
              let {
                icon,
                tooltip,
                clickFunction,
                clickFunctionField,
                renderCondition,
              } = tableIcon;
              if (renderCondition === undefined) {
                renderCondition = () => true;
              }
              
              if (!renderCondition(data)) {
                return null;
              }
              
              // Build clickFunction - if clickFunctionField is null/undefined, pass whole data object
              const boundClickFunction = clickFunction 
                ? () => {
                    if (clickFunctionField === null || clickFunctionField === undefined) {
                      clickFunction(data);
                    } else {
                      clickFunction(data[clickFunctionField]);
                    }
                  }
                : undefined;
              
              // Call icon function with props - icon should return a React element
              const iconElement = typeof icon === 'function' 
                ? icon({ tooltip, clickFunction: boundClickFunction, data })
                : icon;
              
              return (
                <Box key={index}>
                  {iconElement}
                </Box>
              );
            })}
            {props.children}
          </Box>
        </TableCell>
      );
      break;
    default:
      return <TableCell></TableCell>;
  }
};
export default UbilCell;
